import classNames from "classnames";
import React, { PureComponent } from "react";

import { hotjarAttr, IHotjarProps } from "@/browser";

export interface IImgProps extends IHotjarProps {
  /** Source url for image */
  src: string;

  /**
   * Expand component class names
   * @default undefined
   */
  className?: string;

  /**
   * Direction in which image should be responsive
   * @default undefined
   */
  responsive?: "width" | "height";

  /**
   * Expand image to fit the container - Simply set width and height to 100%
   * @default undefined
   */
  strict?: boolean;
}

/**
 * @deprecated Use HTML element instead.
 * Component to display images and set special class to expand image for the container and make this image responsive
 */
export class Img extends PureComponent<IImgProps> {
  render() {
    const { src, className, responsive, strict } = this.props;
    const classes = classNames(
      "el-img",
      {
        [`el-img--responsive-${responsive}`]: !!responsive,
        ["el-img--strict"]: !!strict,
      },
      className,
    );

    return <img src={src} className={classes} {...hotjarAttr(this.props)} />;
  }
}

export default Img;
